import React from "react";

import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import Button from "components/ui/controls/button/button";
import { FaCalculator, FaSync } from "react-icons/fa";
import CheckBox from "components/ui/controls/check-box/check-box";
import { createStyledButton } from "components/ui/controls/button/button-styles";

function RevenusRetraiteCell(props) {
  const {  Annee, Revenus, Trimestre, CheckboxTrimestre, CheckboxDeplafondPass } = props;
  const context = useContext(AppContext);
  let Today = new Date();  return (
    <li
      key={Annee}
      style={{
        background: "#fff",
        borderRadius: "12px",
        boxShadow: "0 1px 4px rgba(99,102,241,0.06)",
        padding: "8px 0 8px 12px",
        marginBottom: "14px",
        display: "flex",
        alignItems: "center",
        position: "relative",
        border: "1.5px solid #d1d5db",
        transition: "box-shadow 0.2s",
      }}
    >
      <span
        style={{
          fontWeight: 700,
          fontSize: "12px",
          color: " #6366f1",
          fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
          minWidth: 70,
          marginRight: 18,
          background: "#f1f5ff",
          border: "1.5px solid #6366f1",
          borderRadius: "8px",
          padding: "4px 12px",
          display: "inline-block",
          textAlign: "center",
        }}
      >
        {Annee}
      </span>
      
      {/* Champ des revenus */}
      {context.state.RetraiteActivite !== "Chomage" &&
       context.state.RetraiteActivite !== "Maladie" &&
       context.state.RetraiteActivite !== "Maternite" &&
       context.state.RetraiteActivite !== "Invalidite" &&
       context.state.RetraiteActivite !== "TrimSpecifique" ? (
        <>
          {Annee < 2002 && (
            <TextField
              value={Revenus}
              onChange={(e) => {
                props.onModifyRevenus(Annee, e);
                props.CalculTrimestre(Annee, e);
              }}
              dataType="uint"
              format={{ thousands: " ", unit: " FRF" }}
              style={{
                width: "230px",
                marginRight: 18,
              }}
            />
          )}
          {Annee >= 2002 && Annee < 2019 && (
            <TextField
              value={Revenus}
              onChange={(e) => {
                props.onModifyRevenus(Annee, e);
                props.CalculTrimestre(Annee, e);
              }}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              style={{
                width: "230px",
                marginRight: 18,
              }}
            />
          )}
          {Annee >= 2019 && (
            <TextField
              disabled={context.state.IdPeriodeRetraite === "CarriereActuelle" ? true : false}
              value={Revenus}
              onKeyUp={(e) => {
                props.onModifyRevenus(Annee, e);
              }}
              onBlur={() => {
                props.CalculTrimestre();
              }}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              style={{
                width: "230px",
                marginRight: 18,
              }}
            />
          )}
        </>
      ) : (
        <div style={{ width: "230px", marginRight: 18 }} />
      )}

      {/* Champ des trimestres */}
      {props.DisplayTrimestre === true && (
        <TextField
          iconBefore={
            <Button
              tabIndex="-1"
              icon
              onClick={(e) => {
                props.onCheck(Annee, false, "CheckboxTrimestre", props.DetailRetraiteConcerne);
                props.CalculTrimestre(Annee, context.state[props.DetailRetraiteConcerne][Annee]["Salaire"]);
              }}
              {...createStyledButton("card-action", "cardEdit", { backgroundColor: "#dbeafe" })}
            >
              {!CheckboxTrimestre ? <FaCalculator style={{ color: "#3b82f6", fontSize: "12px" }} /> : <FaSync style={{ color: "#3b82f6", fontSize: "12px" }} />}
            </Button>
          }
          disabled={Annee>=(Today.getFullYear()) &&  context.state.RetraiteActivite!=="Msa"}
          value={Trimestre}
          onChange={(e) => {
            props.onCheck(Annee, true, "CheckboxTrimestre", props.DetailRetraiteConcerne);
            props.onModifyTrimestre(Annee, e.target.value, props.DetailRetraiteConcerne);
          }}
          dataType="uint"
          style={{
            width: "120px",
            marginRight: 18,
          }}
        />
      )}

      {/* Checkbox déplafond PASS */}
      {props.DisplayDeplafondPass === true && Annee < 2005 && (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "120px", marginRight: 18 }}>
          <CheckBox
            checked={true}
            unchecked={false}
            value={CheckboxDeplafondPass}
            onChange={(e) => {
              props.onCheck(Annee, e.target.checked, "CheckboxDeplafondPass", props.DetailRetraiteConcerne);
            }}
            style={{marginBottom:0}}
          />
        </div>
      )}
      {props.DisplayDeplafondPass === true && Annee >= 2005 && (
        <div style={{ width: "80px", marginRight: 18 }}></div>
      )}

      <span style={{ flex: 1 }}></span>
    </li>
  );
}

export default RevenusRetraiteCell;
